import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';

import EnterpriseButton from '@webclient/components/enterprise-button';
import { StyledGradientText } from '@webclient/components/pages/styles';
import CreditPack from '@webclient/components/plans/kinds/credit-pack';
import GeniusSearch from '@webclient/components/plans/kinds/genius-search';
import GeniusTeams from '@webclient/components/plans/kinds/genius-teams';
import {
  StyledContainerStack,
  StyledGrid,
  StyledWrapperStack,
} from '@webclient/components/plans/styles';

import { Text } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

export default function Plans() {
  const { t } = useTranslate();

  return (
    <StyledContainerStack gap={6}>
      <StyledWrapperStack>
        <EnterpriseButton />
        <Box>
          <StyledGradientText
            variant="displayLg"
            weight="semibold"
          >
            {t('layout.upgrade.title', 'Smart, Scalable Plans')}
          </StyledGradientText>
          <Text
            variant="textLg"
            weight="medium"
            color="text.tertiary"
          >
            {t(
              'layout.upgrade.subtitle',
              'Pick a plan today to see why Knowz better',
            )}
          </Text>
        </Box>
      </StyledWrapperStack>
      <StyledGrid
        container
        spacing={3}
      >
        {[<CreditPack />, <GeniusSearch />, <GeniusTeams />].map(
          (Plan, index) => (
            <Grid2
              size={{
                xs: 12,
                sm: 12,
                md: 4,
              }}
              key={index}
            >
              {Plan}
            </Grid2>
          ),
        )}
      </StyledGrid>
      {/* 
      //TODO: we will turn it on, once we have automatic credit top up and refines over the details
      <Text
        variant="textXs"
        color="text.secondary"
        sx={{
          textAlign: 'center',
        }}
      >
        {t(
          'layout.upgrade.extraInfo',
          '*Credits are consumed at varying rates for files and searches based on complexity, size and type, values displayed refer to average search lengths and file sizes. **Knowledge Storage covers only files saved to workspace knowledgebases. Synced files and temporary uploads to the Search widget consume platform credits and don’t count toward storage. Credits are used for processing and search at varying rates - For more details see our Terms of Service. Additional Knowledge Storage is consumed at 1 credit per 10MB, up to a maximum of 1TB total Knowledge Storage per Knowledgebase. For larger teams or storage needs, enquire about our Enterprise Packages. ^Automatic credit top ups cost US$29.95 for 2,000 credits and are automatically charged to your selected payment method whenever your credit balance reaches zero. You can cancel at any time.',
        )}
      </Text> 
      */}
    </StyledContainerStack>
  );
}
